<template>
    <div class="position-box">
        <div class="head">
            <div class="back-box" @click="goBack"><img class="icon" src="@/assets/icon_back.png" alt="back"></div>
        </div>
        <div class="bg">
            <ul class="list-box">
                <li class="list">
                    <div class="title">{{$t('langNew.yxbd')}}</div>
                </li>
                <!-- 邮箱账号 -->
                <li class="list list-code">
                    <input class="input" type="text" v-model="email" :placeholder="$t('langNew.qsryxzh')">
                </li>
                <!-- 验证码 -->
                <li class="list list-code">
                    <div class="input-box">
                        <input class="input" type="text" v-model="code" :placeholder="this.$t('sztxmm.qsryzm')">
                        <input class="code" id="fbtain" type="button" @click="getCode" :value="$t('sztxmm.hqyzm')">
                    </div>
                </li>
                <button class="btn" type="button" @click="sure">{{this.$t('sztxmm.t6')}}</button>
            </ul>
        </div>
    </div>
</template>
<script>
export default {
    name: 'emailBind',
    data () {
        return {
          token: '',
          email: '',
          code: '',
          countdown: 300,
          timer: null,
          count: 1
        }
    },
    mounted(){
      this.token = localStorage.getItem('token');
      $("input").keyup(function(){	//去掉空格
        $(this).val($(this).val().replace(/[, ]/g,''));
      });
    },
    methods: {
      goBack(){
           this.$router.push('/safety')
       },
      sure(){
          var regEmail = /^\S+[@]+\S/;
          var data = {
              email : this.email,
              code : this.code
          }
          if(data.email == "" || data.email == null){
              this.$toast.center(this.$t('langNew.qsryxzh'));
              return false;
          }else if(!regEmail.test(data.email)){
              this.$toast.center(this.$t('langNew.yxgz'));
              return false;
          }
          if(data.code == '' || data.code == null){
              this.$toast.center(this.$t('sztxmm.qsryzm'));
              return false;
          }
          if(this.count == 1){
            this.count = 0;
          }else{
              return false;
          }
          this.$ajax.post('/web/bindemail',data).then((res) => {
              let resData = res.data;
              if(resData.code == 0 || resData.code == 4 || resData.code == 7){
                this.$toast.center(resData.message);
                setTimeout(() => {
                    this.count = 1;
                    this.$router.push('/safety')
                }, 1000)
              }else{
                  this.count = 1;
                  this.$toast.center(resData.message);
                  return;
              }
          }).catch(function(err){
              console.log(err)
          })
       },
       //获取手机邮箱验证码
       getCode(){
          var regEmail = /^\S+[@]+\S/;
           let params = {
               account: this.email,
               type: '',
               token: 1
           }
           if(this.email == '' || this.email == null){
              this.$toast.center(this.$t('langNew.qsryxzh'));
              return;
           }else if(!regEmail.test(this.email)){
              this.$toast.center(this.$t('langNew.yxgz'));
              return false;
          }
           if(this.count == 1){
              this.count = 0;
            }else{
                return false;
            }
           this.$ajax.get('/web/getCode',{params}).then((res) => {
                let resData = res.data;
                if(resData.code == 1){
                    this.$toast.center(resData.message);
                    this.count = 1;
                    return;
                }else{
                  this.count = 1;
                  this.settime()
                }

            }).catch(function(err){
                console.log(err)
            })
       },
       settime(){
           let generate_code = $("#fbtain");
           if (this.countdown == 0) {
                generate_code.attr("disabled", false);
                generate_code.val(this.$t('sztxmm.hqyzm'));
                generate_code.css('color', '#5890bd');
                this.countdown = 300;
                return false;
            } else {
                generate_code.attr("disabled", true);
                generate_code.css('color', '#b6bfc4');
                generate_code.val(this.countdown + ' s');
                this.countdown--;
            }
            this.timer = setTimeout(() => {
                this.settime();
            }, 1000);
       },
    },
     beforeDestroy(){
      clearTimeout(this.timer);
      this.timer = null;
    }
}
</script>
<style scoped>
    input::-webkit-input-placeholder{
        color: #d2d2d2;
        font-size: .42rem;
    }
    .position-box{
        position: absolute;
        left: 0;
        top: 0;
        bottom: 0;
        width: 100%;
        height: auto;
        color: #cecece;
        font-size: .36rem;
        background: url('../assets/element-background.png') no-repeat center center;
        background-size: cover;
        overflow: hidden;
    }
    .head{
        position: relative;
        height: 1.2rem;
        font-size: .36rem;
        line-height: 1.2rem;
        text-align: center;
    }
    .head .icon{
        position: absolute;
        left: .3rem;
        top: .3rem;
        width: .32rem;
        height: .6rem;
    }
    .bg{
        position: absolute;
        width: 100%;
        height: calc(100% - .8rem);
    }
    .list-box{
        padding: 0 .3rem;
        color: #ababab;
    }
    .list-box .list.list-code{
      border-bottom: 1px solid #858585;
    }
    .list-box .list .title{
      color: #fff;
      font-size: .72rem;
    }
    .list-box .list-text{
        font-size: .42rem;
    }
    .list-box .input-box{
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-radius: 4px;
    }
    .list-box .list{
      padding: .48rem 0 .48rem .24rem;
    }
    .list-box .list .input{
        width: 100%;
        height: .8rem;
        color: #d0d0d0;
        font-size: .48rem;
        background: transparent;
    }
    .list-box .input-box .input{
        flex: 1;
        height: .8rem;
        border: none;
    }
    .list-box .input-box .code{
        color: #fff;
        font-size: .42rem;
    }
    .tips{
        margin-top: .2rem;
        color: #2CAADE;
        font-size: .42rem;
        text-align: right;
    }
    .btn {
        width: 100%;
        height: 1.2rem;
        margin-top: 2.6rem;
        color: #fff;
        font-size: .48rem;
        line-height: 1.2rem;
        background: linear-gradient(left, rgba(44, 170, 222, 0.5), rgba(93, 205, 233, 0.5));
        border-radius: .2rem;
    }
</style>



// WEBPACK FOOTER //
// src/pages/emailBind.vue